<template>
  <layout-default :drawer-items="drawer.items">
    <div
      class="views network index"
    >
      <v-container>
        <info-header/>
        <components-common-reader />
        <components-common-voucher-history />
        <components-module-event-finish :showFinish="true" :event="event" />
      </v-container>
    </div>
  </layout-default>
</template>

<script>
import ComponentsCommonReader from '@/components/common/Reader.vue'
import ComponentsCommonVoucherHistory from '@/components/common/VoucherHistory'
import ComponentsModuleEventFinish from '@/components/module/EventFinish'
import LayoutDefault from '@/layouts/Default'
import InfoHeader from '@/layouts/partials/InfoHeader'
import RouterGuardsNetwork from '@/router/guards/network'

export default {
  name: `NetworkIndex`,

  components: {
    ComponentsCommonReader,
    ComponentsCommonVoucherHistory,
    ComponentsModuleEventFinish,
    LayoutDefault,
    InfoHeader
  },

  created() {
    RouterGuardsNetwork.indexAuthorization()
  },
  
  data: () => ({
    drawer: {
      items: [
        {
          icon: 'fa-solid fa-shield-halved',
          title: 'producers',
          toRouteName: 'producer_index'
        },
        {
          icon: 'fa-solid fa-calendar-days',
          title: 'events',
          toRouteName: 'event_index'
        },
        {
          icon: 'mdi-barcode-scan',
          title: 'reading',
          toRouteName: 'index'
        },
        {
          icon: 'fa-solid fa-grid-2',
          title: 'sections',
          toRouteName: 'network_section'
        },
      ]
    }
  }),
  
  methods: {
    //
  },

  computed: {
    event() {
      return this.$store.state.events.selected
    }
  }
}
</script>

<style lang="scss">

</style>
